<template>
  <div>
    <v-app-bar
      elevate-on-scroll app
      color="transparent"
      class="pba-appbar pba-appbar-menu"
    >
      <div
        id="appbar"
        class="pba-appbar-menu d-flex flex-grow-1 align-center white"
        :class="
          drawer
            ? 'pba-primary'
            : $route.name === 'Home' && (!isMobile && isOnTop) && 'transparent'
        "
      >
        <v-container class="d-flex align-center pba-appbar-container mx-0">
          <img
            id="appbar-logo"
            class="pba-logo cursor-pointer"
            :src="website_data.profile.hotel_logo"
            @click="$route.name !== 'Home' && $router.push({ name: 'Home' })"
          >

          <v-spacer />

          <div>
            <v-tabs
              class="hidden-md-and-down"
              background-color="transparent"
            >
              <v-tabs-slider color="transparent" />
              <v-tab
                v-for="({ text, id }, i) in items"
                v-show="i !== 'book'"
                :key="i"
                text color="white"
                :ripple="false"
                class="pba-appbar-tab-text px-8"
                :class="
                  isVisible[i] || (i === 'news' && $route.name === 'News')
                    ? isOnTop ? 'pba-secondary--text' : 'pba-primary--text'
                    : $route.name === 'Home' && isOnTop ? 'white--text' : 'black--text'
                "
                @click="goTo(id); gtagClickEvent('Navbar', items[i].text)"
                v-text="text"
              />
            </v-tabs>
          </div>

          <v-expand-x-transition mode="out-in">
            <div v-if="website_data.profile.hotel_simplebooking && !isVisible.book">
              <v-btn
                id="appbar-book"
                elevation="0" tile color="pba-primary"
                class="pba-btn-book white--text text-uppercase ms-5"
                :href="toQueryUrl(website_data.profile.hotel_simplebooking, utm_data)"
                target="_blank" rel="noopener nofollow"
                @click="gtagClickEvent('Navbar', label_data.BOOK_NOW)"
                v-text="label_data.BOOK_NOW"
              />
            </div>
          </v-expand-x-transition>

          <v-btn
            fab icon :color="
              drawer
                ? 'white'
                : $route.name === 'Home' && (!isMobile && isOnTop) ? 'white' : 'black'
            "
            :ripple="false"
            class="d-lg-none ms-5"
            @click="drawer = !drawer"
          >
            <v-fade-transition mode="out-in">
              <v-icon v-if="drawer" key="1">
                mdi-close
              </v-icon>
              <v-icon v-else key="2">
                mdi-menu
              </v-icon>
            </v-fade-transition>
          </v-btn>
        </v-container>
      </div>
      <v-fade-transition>
        <div v-if="drawer" class="d-lg-none pba-appbar-menu-mobile pba-primary">
          <v-container class="d-flex flex-column align-end white--text fill-height pa-12">
            <v-btn
              v-for="({ text, id }, i) in items" v-show="i !== 'book'"
              :key="i"
              tile text color="white"
              :ripple="false"
              class="pba-appbar-tab-mobile-text pa-0 mb-6"
              :class="isVisible[i] && 'pba-appbar-tab-mobile-text pba-secondary--text'"
              @click="
                goTo(id)
                drawer = false
              "
              v-text="text"
            />
          </v-container>
        </div>
      </v-fade-transition>
    </v-app-bar>
    <v-slide-y-reverse-transition>
      <v-btn
        v-show="!isOnTop"
        fab tile fixed bottom right
        class="pba-btn-slide pba-primary--text"
        color="pba-secondary" elevation="0"
        @click="$vuetify.goTo(0)"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-slide-y-reverse-transition>
  </div>
</template>

<script>

  export default {
    name: 'AppBar',

    data () {
      return {
        isOnTop: true,
        drawer: null,

        enableScrollViews: true,

        isVisible: {
          about: false,
          rooms: false,
          meetings: false,
          facilities: false,
          photos: false,
          news: false,
          contact: false,
          book: true,
        },

        viewedSection: {
          about: false,
          rooms: false,
          meetings: false,
          facilities: false,
          photos: false,
          news: false,
          contact: false,
          book: false,
        },
      }
    },

    computed: {
      items () {
        const items = {
          about: { text: this.label_data.MENU_ABOUTUS, id: 'section-about' },
          rooms: { text: this.label_data.MENU_ROOMS, id: 'section-rooms' },
          meetings: { text: this.label_data.MENU_MEETINGS, id: 'section-meetings' },
          facilities: { text: this.label_data.MENU_FACILITIES, id: 'section-facilities' },
          offers: { text: this.label_data.MENU_OFFERS, id: 'section-offers' },
          photos: { text: this.label_data.MENU_PHOTOS, id: 'section-photos' },
          news: { text: this.label_data.MENU_NEWS, id: 'section-news' },
          contact: { text: this.label_data.MENU_CONTACT, id: 'footer' },
          book: { text: 'HERO & BOOK', id: 'form-book' },
        }

        !(this.website_data.press?.length) && delete items.news
        !(this.website_data.meeting?.length) && delete items.meetings
        !(this.website_data.facility?.length) && delete items.facilities
        !(this.website_data.offers?.length) && delete items.offers

        return items
      },
    },

    mounted () {
      window.addEventListener('scroll', this.onScroll)
    },

    updated () {
      this.checkVisibilities()
    },

    beforeDestroy () {
      window.removeEventListener('scroll', this.onScroll)
    },

    methods: {
      checkVisibilities () {
        // Check if at least half of element is visible
        const offset = document.getElementById('appbar').offsetHeight

        Object.keys(this.items).forEach(i => {
          let el = document.getElementById(this.items[i].id)
          if (!el) return (this.isVisible[i] = false)
          const { offsetHeight } = el
          el = el.getBoundingClientRect()

          this.isVisible[i] =
            el.top - offset > -offsetHeight * 0.5 &&
            el.bottom < (window.innerHeight || document.documentElement.clientHeight) + offsetHeight * 0.5

          if (this.enableScrollViews && !this.viewedSection[i] && this.isVisible[i]) {
            this.viewedSection[i] = true
            this.gtagViewEvent(this.items[i].text)
          }
        })
      },

      onScroll () {
        this.isOnTop = window.top.scrollY === 0
        this.checkVisibilities()
      },

      goTo (id) {
        this.enableScrollViews = false
        this.$route.name === 'Home'
          ? this.$vuetify.goTo('#' + id, { appOffset: false, offset: document.getElementById('appbar').offsetHeight })
            .then(() => { this.enableScrollViews = true })
          : this.$router.push({ name: 'Home', query: { go: id } })
      },
    },
  }
</script>

<style lang="scss">
</style>
